import React from "react";
import Departments from "../../organization/Departments";

/** Admin > Departments: reuses standalone Departments page body (no extra chrome). */
function DepartmentsScreen(company_id) {
  const companyId = Number(company_id?.company_id);
  return <Departments company_id={companyId}/>;
}

export default DepartmentsScreen;
